import { gql } from '@apollo/client';

export const CREATE_VEHICLE_MODEL = gql`
    mutation CreateVehicleModel($input: VehicleModelInput!) {
        createVehicleModel(input: $input)
    }
`;

export const UPDATE_VEHICLE_MODEL = gql`
    mutation UpdateVehicleModel($input: VehicleModelInput!) {
        updateVehicleModel(input: $input)
    }
`;

export const CREATE_VEHICLE_TYPE = gql`
    mutation CreateVehicleType($input: VehicleTypeInput!) {
        createVehicleType(input: $input)
    }
`;

export const UPDATE_VEHICLE_TYPE = gql`
    mutation UpdateVehicleType($input: VehicleTypeInput!) {
        updateVehicleType(input: $input)
    }
`;
